<template>
	<footer class="footer mt-auto py-3 bg-light">
		<div class="container">
			<span class="fs-auto">© 2008 - {{ new Date().getFullYear() }} &nbsp;<a href="https://xalan.sk">Xalan s.r.o</a></span>
		</div>
	</footer>
</template>
